import * as constants from '@/common/constants';

export default {
    state: {
        workPlantEntry: constants.VUEX_WORK_PLANT_ENTRY
    },
    mutations: {
        [constants.VUEX_MUTATIONS_WORK_PLANT_ENTRY]: (state, workPlantEntry) => {
            state.workPlantEntry = workPlantEntry;
        }
    },
    actions: {
        [constants.VUEX_ACTIONS_WORK_PLANT_ENTRY] ({ commit }, workPlantEntry) {
            commit(constants.VUEX_MUTATIONS_WORK_PLANT_ENTRY, workPlantEntry);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-work-plant-entry.js